<template>
    <div class="helpcon">
        <p style=" line-height: 52px;font-size: 12px;color: #666;text-align: left"> 帮助中心</p>
        <div  style="width: 210px;margin-right: 20px;float: left;background: #fff;min-height: 600px" class="item">
            <mu-container style="    padding: 0;">
                <mu-expansion-panel>
                    <div class="helpconhover" slot="header" style="  font-size: 12px;width: 130px;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;float: left;" @click="changeactive(0)" :class="active[0]+''+active[1]">商城设置</div>
                    <p class="helpconhover" style="font-size: 12px" @click="changeactive(0)" :class="active[0]">基础设置</p>
                    <p class="helpconhover" style="font-size: 12px"  @click="changeactive(1)" :class="active[1]">API管理</p>
                </mu-expansion-panel>
                <mu-expansion-panel>
                    <div class="helpconhover" slot="header" style="  font-size: 12px;width: 130px;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;float: left;"  @click="changeactive(2)" :class="active[2]+''+active[3]">上架商品</div>
                    <p class="helpconhover" style="font-size: 12px"  @click="changeactive(2)" :class="active[2]">自有商品</p>
                    <p class="helpconhover" style="font-size: 12px" @click="changeactive(3)" :class="active[3]">API商品</p>
                </mu-expansion-panel>
                <mu-expansion-panel>
                    <div class="helpconhover"   slot="header" style="  font-size: 12px;width: 130px;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;float: left;"  @click="changeactive(4)" :class="active[4]+''+active[5]">营销功能</div>
                    <p class="helpconhover"style="font-size: 12px"  @click="changeactive(4)" :class="active[4]">代理改价</p>
                    <p class="helpconhover"style="font-size: 12px" @click="changeactive(5)" :class="active[5]">卡密拼团</p>
                </mu-expansion-panel>
                <mu-expansion-panel>
                    <div class="helpconhover"slot="header" style="  font-size: 12px;width: 130px;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;float: left;" @click="changeactive(6)" :class="active[6]+''+active[7]+''+active[8]">自动发货</div>
                    <p class="helpconhover"style="font-size: 12px" @click="changeactive(6)" :class="active[6]">虚拟卡密</p>
                    <p class="helpconhover"style="font-size: 12px" @click="changeactive(7)" :class="active[7]">图片二维码</p>
                    <p class="helpconhover"style="font-size: 12px" @click="changeactive(8)" :class="active[8]">手动代充</p>
                </mu-expansion-panel>
                <mu-expansion-panel>
                    <div class="helpconhover"slot="header" style="  font-size: 12px;width: 130px;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;float: left;"  @click="changeactive(9)" :class="active[9]+''+active[10]+''+active[11]">代理管理</div>
                    <p class="helpconhover"style="font-size: 12px" @click="changeactive(9)" :class="active[9]">代理列表</p>
                    <p class="helpconhover"style="font-size: 12px" @click="changeactive(10)" :class="active[10]">代理审核</p>
                    <p class="helpconhover"style="font-size: 12px" @click="changeactive(11)" :class="active[11]">代理商教程</p>
                </mu-expansion-panel>
                <mu-expansion-panel>
                    <div class="helpconhover"slot="header" style="  font-size: 12px;width: 130px;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;float: left;"  @click="changeactive(12)" :class="active[12]">提现管理</div>
                    <p class="helpconhover"style="font-size: 12px" @click="changeactive(12)" :class="active[12]">提现须知</p>
                </mu-expansion-panel>

            </mu-container>
        </div>
        <div style="    width: 970px; padding: 16px 30px;min-height: 600px;float: left;background: #fff;">
          <h2>  内容正在建设中...</h2>
        </div>

    </div>
</template>
<script>
    export default {
        name: 'helpcon',
        data(){
            return{
                active:['active','','','','','','','','','','','','']
            }
        },
        methods:{
            changeactive(k){
                for (var i = 0 ;i<this.active.length;i++){
                    this.$set(this.active,i, '');
                }
                this.$set(this.active,k, 'active');
            }
        }
    }
</script>
<style scoped>
    .helpcon{
        width: 1205px;
        margin: 0 auto;
        overflow: hidden;
    }
    .helpconhover{
        cursor: pointer;
    }
    .helpconhover:hover{
        color: #fb6638;
    }
    .item div{
        border: none !important;
        box-shadow: 0px 0px 0px #fff !important;
    }
    .active{
        color: #fb6638;
    }
</style>


// WEBPACK FOOTER //
// src/components/help/helpcon.vue